import { queryOptions } from '@tanstack/react-query';
import { HttpService } from '@Services/index';

export interface AuthUserAddressResponse {
  city: string;
  state: string;
  line1: string;
  line2: string;
  postalCode: string;
  country: string;
}

export const getAuthUserAddress = async (customerId: string, authorizedUserId: string) => {
  const url = `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/address`;
  const { data } = await HttpService.get<AuthUserAddressResponse>(url);
  return data;
};

export const getAuthUserAddressQueryOptions = (customerId: string, authorizedUserId: string) =>
  queryOptions({
    queryKey: ['authUserAddress', customerId, authorizedUserId],
    queryFn: () => getAuthUserAddress(customerId, authorizedUserId),
  });
